import {db} from '@core/JsStore/idb';
import {Table} from 'dexie';

export function getEntityTable(tableId: string): Table {
    return (db as any)[tableId] as Table;
}
